﻿/* https://brandplatform.smartphoto.com/general/molecules/review-blocks/ */
import {expressQuerySelector, expressQuerySelectorAll, remove, show} from "../../common/html";
import {IProductCategoryReview} from "../../services/content-service";
import {createCollapsable} from "./collapsable";

interface ICreateReviewBlocksOptions {
	readonly productReviewsNameLabel: string;
	readonly productReviewsAnonymousLabel: string;
}

export function createReviewBlocks(containerEl: HTMLElement, options: Partial<ICreateReviewBlocksOptions>) {

	const {productReviewsNameLabel, productReviewsAnonymousLabel = "Anonymous"} = options;
	const reviewTemplateEl = expressQuerySelector<HTMLElement>(containerEl, '.m-review-block.template', true);
	remove(reviewTemplateEl);
	const collapsableCommentEls = expressQuerySelectorAll<HTMLElement>(containerEl, '.technical-review-answer-collapsable');

	collapsableCommentEls.forEach(el => createCollapsable(el, null, { swapTitleDataAttribute : "data-hidelabel" }));

	const createUserReview = (review: IProductCategoryReview): HTMLElement => {

		const reviewTemplateCloneEl: HTMLElement = reviewTemplateEl.cloneNode(true) as HTMLElement;

		// stars block
		const reviewStarsEl = expressQuerySelector<HTMLElement>(reviewTemplateCloneEl, ".m-review-blocks__stars", true);
		const fullStarsEl = expressQuerySelector<HTMLElement>(reviewStarsEl, ".a-review-stars__full", true);
		fullStarsEl.style.width = `${review.score * 100 / 5}%`; // TODO : get max score
		const reviewsStarsAtomEl = expressQuerySelector<HTMLElement>(reviewStarsEl, ".a-review-stars", true);
		if (review.trustPilotDesignClass)
			reviewsStarsAtomEl.classList.add(...review.trustPilotDesignClass.split(" "));

		// review
		if (review.comment)
			expressQuerySelector(reviewTemplateCloneEl, ".m-review-blocks__review", true)
				.insertAdjacentText('beforeend', review.comment);

		// user info
		const reviewerBlockEL = expressQuerySelector<HTMLElement>(reviewTemplateCloneEl, ".m-review-blocks__reviewer", true);

		// if no label provided -> don't show names at all
		if (productReviewsNameLabel) {
			const name = `${review.reviewerFirstname || ""} ${review.reviewerLastname || ""}`;
			expressQuerySelector(reviewerBlockEL, ".m-review-blocks__reviewer-name", true)
				.insertAdjacentText('beforeend', `${productReviewsNameLabel.replace('{0}', name.trim() || productReviewsAnonymousLabel)}`);
		} else {
			expressQuerySelector<HTMLElement>(reviewerBlockEL, ".m-review-blocks__reviewer-name", true).style.display = 'none';
		}

		if (review.formattedReviewDate)
			expressQuerySelector(reviewerBlockEL, ".m-review-blocks__review-date", true)
				.insertAdjacentText('beforeend', review.formattedReviewDate);

		// comment collapsable
		const collapsableEl = expressQuerySelector<HTMLElement>(reviewTemplateCloneEl, ".technical-review-answer-collapsable", true);
		const commentBlockEl = expressQuerySelector<HTMLElement>(collapsableEl, ".m-review-answer", true);
		if (review.feedback && review.formattedFeedbackDate) {
			expressQuerySelector(commentBlockEl, ".m-review-answer__answer-date", true)
				.insertAdjacentText('beforeend', review.formattedFeedbackDate);
			expressQuerySelector(commentBlockEl, ".m-review-answer__answer", true)
				.insertAdjacentHTML("beforeend", `<span>${review.feedback}</span>`);
			createCollapsable(collapsableEl, null, { swapTitleDataAttribute : "data-hidelabel"});
		} else {
			remove(collapsableEl);
		}

		show(reviewTemplateCloneEl);

		return reviewTemplateCloneEl;
	};

	const addReviews = (productCategoryReviews: IProductCategoryReview[], replace = false) => {
		const reviewEls = productCategoryReviews.map(r => createUserReview(r));
		if (replace) clear();
		containerEl.append(...reviewEls);
	};

	const clear = () => containerEl.innerHTML = '';

	return {
		addReviews,
		clear,
	};
}
